module.exports = require("./khq.js");